<template>

  <section class="login">
    <div class="container-scroller">
      <div class="container-fluid page-body-wrapper full-page-wrapper">
        <div class="content-wrapper d-flex align-items-center auth">
          <div class="row w-100 flex-grow" v-show="!loading">
            <div class="col-xl-4 col-lg-6 mx-auto">
              <div class="auth-form-dark text-left p-5">
                <div class="brand-logo">
                  <b-link to="/"><img src="@/assets/logo_tnc-cup_dark.png"></b-link>
                </div>
                <h4>Hello! let's get started</h4>
                <h6 class="font-weight-light">Sign in to continue.</h6>
                <form class="pt-3">
                  <div class="form-group">
                    <b-form-input type="email" class="form-control form-control-lg" id="email" placeholder="Email"
                      v-model='$v.form.email.$model'
                      :error-messages="error"
                      @input="$v.form.email.$touch()"
                      @blur="$v.form.email.$touch()"
                      :state="$v.form.email.$dirty ? !$v.form.email.$error : null"
                      aria-describedby="email-feedback"
                      required
                      outlined
                    ></b-form-input>
                    <b-form-invalid-feedback id="email-feedback">
                      {{ emailErrors[0] }}
                    </b-form-invalid-feedback>
                  </div>
                  <div class="form-group">
                    <b-form-input class="form-control form-control-lg" id="password" type="password" placeholder="Password"
                      v-model='$v.form.password.$model'
                      :error-messages="error"
                      required
                      @input="$v.form.password.$touch()"
                      @blur="$v.form.password.$touch()"
                      :state="$v.form.password.$dirty ? !$v.form.password.$error : null"
                      aria-describedby="password-feedback"
                      outlined
                    ></b-form-input>
                    <b-form-invalid-feedback id="email-feedback">
                      {{ passErrors[0] }}
                    </b-form-invalid-feedback>
                  </div>
                  <div class="mt-3">
                    <b-button v-on:click='signIn' class="btn btn-block btn-gradient-primary btn-lg font-weight-medium auth-form-btn">SIGN IN</b-button>
                  </div>
                  <div class="my-3 text-right">
                    <b-link to="forgot" class="auth-link text-info">Forgot password?</b-link>
                  </div>
                  <div class="mb-2">
                    <button type="button" v-on:click="signInGoogle" class="btn btn-block btn-google auth-form-btn">
                      <i class="mdi mdi-google mr-2"></i>Sign in with Google
                    </button>
                  </div>
                  <div class="mb-2">
                    <button type="button" v-on:click="signInAmazon" class="btn btn-block btn-amazon auth-form-btn">
                      <i class="mdi mdi-amazon mr-2"></i>Sign in with Amazon
                    </button>
                  </div>
                  <div class="mb-2">
                    <button type="button" v-on:click="signInFacebook" class="btn btn-block btn-facebook auth-form-btn">
                      <i class="mdi mdi-facebook mr-2"></i>Sign in with facebook
                    </button>
                  </div>
                  <div class="text-center mt-4 font-weight-light">
                    Don't have an account? <router-link to="/signup" class="text-primary">Sign Up</router-link>
                  </div>
                </form>
                <div class="my-3 text-center text-uppercase">
                  <p class="text-center text-danger">{{ error.message }}</p>
                </div>
              </div>
            </div>
          </div>
        <div class="dot-opacity-loader" v-show="loading">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
      <!-- content-wrapper ends -->
      </div>
      <!-- page-body-wrapper ends -->
    </div>
  </section>

</template>

<script>
import { Auth } from 'aws-amplify'
import { validationMixin } from 'vuelidate'
import { required, minLength, email } from 'vuelidate/lib/validators'

export default {
  name: 'login',
  mixins: [validationMixin],
  validations: {
    form: {
      email: { required, email },
      password: {
        required,
        minLength: minLength(8),
        containsUppercase: function(value) {
          return /[A-Z]/.test(value)
        },
        containsLowercase: function(value) {
          return /[a-z]/.test(value)
        },
        containsNumber: function(value) {
          return /[0-9]/.test(value)
        },
        containsSpecial: function(value) {
          return /[#?!@$%^&*-]/.test(value)
        }
      }
    }
  },
  data() {
    return {
      loading: false,
      formState: 'signIn',
      showpass: false,
      signInError: { message: null },
      forgotError: { message: null },
      forgotSubmitError: { message: null },
      error: { message: null },
      form: {
        email: null,
        password: null
      },
      authCode: null
    }
  },
  computed: {
    emailErrors () {
      const errors = []
      if (!this.$v.form.email.$dirty) return errors
        //!this.$v.oldPass.maxLength && errors.push('Name must be at most 10 characters long')
        !this.$v.form.email.email && errors.push('Must be valid e-mail')
        !this.$v.form.email.required && errors.push('Required!')
      return errors
    },
    passErrors () {
      const errors = []
      if (!this.$v.form.password.$dirty) return errors
        //!this.$v.newPass.email && errors.push('Must be valid e-mail')
        !this.$v.form.password.minLength && errors.push('Must be at least 8 characters')
        !this.$v.form.password.containsUppercase && errors.push('Must contain uppercase')
        !this.$v.form.password.containsLowercase && errors.push('Must contain lowercase')
        !this.$v.form.password.containsNumber && errors.push('Must contain number')
        !this.$v.form.password.containsSpecial && errors.push('Must contain special chars')
        !this.$v.form.password.required && errors.push('Required!')
      return errors
    },
    // authCodeErrors () {
    //     const errors = []
    //     if (!this.$v.authCode.$dirty) return errors
    //         !this.$v.authCode.required && errors.push('Required!')
    //     return errors
    // }
  },
  methods: {
    async signIn() {
        this.$v.$touch()
        if (this.$v.form.$anyError) {
          this.loading = false;
          return
        }
        this.loading = true;
        // Fields validated
        if (!this.$v.$invalid) {
            await Auth.signIn(this.form.email, this.form.password)
                .then(user => console.log('success'))
                .catch(err => {this.error = err, this.loading = false})
        }
    },
    signInGoogle: async function() {
      let res = await Auth.federatedSignIn({provider: 'Google'});
    },
    signInFacebook: async function() {
      let res = await Auth.federatedSignIn({provider: 'Facebook'});
    },
    signInAmazon: async function() {
      let res = await Auth.federatedSignIn({provider: 'LoginWithAmazon'});
    },
    // async forgot() {
    //     await Auth.forgotPassword(this.email)
    //         .then(user => this.formState = 'forgotSubmit')
    //         .catch(err => this.forgotError = err)
    // },
    // async forgotSubmit() {
    //     await Auth.forgotPasswordSubmit(this.email, this.authCode, this.password)
    //         .then(user => this.toggleForgot()) // show sign in again
    //         .catch(err => this.forgotSubmitError = err)
    // },
    // toggleForgot() {
    //     this.formState === 'signIn' ? this.formState = 'forgotPassword' : this.formState = 'signIn'
    // }
  }
}
</script>
